<nav
  class="navbar navbar-expand-md header navbar-dark d-flex flex-row justify-content-between"
>
  <div class="header-logo d-flex align-items-center">
    <div class="d-flex flex-row justify-content-between">
      <a class="navbar-brand" routerLink="dashboard">
        <img [src]="navLogo" alt="" class="logo" />
      </a>
      <app-drop-down [sites]="siteItem"></app-drop-down>
    </div>
  </div>
  <div class="tab-navigation d-none d-lg-block mr-5">
    <div class="tab-btns mr-5">
      <ul class="navbar-nav navbar-center">
        <li class="nav-item" (click)="onSelected(CONSTANTS.DASHBOARD)">
          <a
            routerLink="dashboard"
            routerLinkActive="btn-Selected"
            type="button"
            class="btn btn-secondary text-align-center toggle-button"
          >
            <img
              src="assets/svg/ico-square-menu.svg"
              class="dashboard-icon"
            />&nbsp; {{ 'DASHBOARD' | translate }}
          </a>
        </li>
        <li class="nav-item" (click)="onSelected(CONSTANTS.LOCATIONS)">
          <a
            type="button"
            routerLink="site-management"
            routerLinkActive="btn-Selected"
            class="btn btn-secondary text-align-center toggle-button"
          >
            <img src="assets/svg/ico-building.svg" class="building-icon" />
            {{ 'LOCATIONS' | translate }}
          </a>
        </li>
        <li class="nav-item" (click)="onSelected(CONSTANTS.USERS)">
          <a
            type="button"
            routerLink="users"
            routerLinkActive="btn-Selected"
            class="btn btn-secondary text-align-center toggle-button"
          >
            <img src="assets/svg/ico-lock-user-access.svg" class="user-icon" />
            {{ 'USERS' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="user-drop-down ml-5">
    <div class="d-none d-md-block">
      <ul class="nav nav-pills bg-dark nav">
        <li class="user-setting dropdown nav pr-4" *ngIf="user | async as user">
          <button
            class="btn btn-secondary drp-btn"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            matTooltip="{{ user?.name }}"
            [matTooltipDisabled]="user?.name.length < 12"
          >
            <app-profile-picture [name]="user.name" [userData]="user">
            </app-profile-picture>
            <span class="pl-2 user-name-text"
              >{{ 'HI_TEXT' | translate }} {{ user?.name }}
            </span>

            <img src="assets/svg/ico-down-arrow.svg" />
          </button>

          <div class="dropdown-menu dropdown-menu-right">
            <div class="triangle-with-shadow"></div>
            <br />
            <br />
            <a class="dropdown-item pl-5">
              {{ 'LOGED_IN_AS' | translate }}
            </a>
            <h2 class="pl-5 user-name">
              <app-with-tooltip [showHelpCursor]="true">
                {{ user?.name }}
              </app-with-tooltip>
            </h2>

            <span class="d-block d-lg-none">
              <a
                (click)="onSelected(CONSTANTS.DASHBOARD)"
                [ngClass]="
                  sharedData?.headerTab === CONSTANTS.DASHBOARD
                    ? 'dropdown-item pl-5 active'
                    : 'dropdown-item pl-5'
                "
                >{{ 'DASHBOARD' | translate }}</a
              >
              <a
                (click)="onSelected(CONSTANTS.LOCATIONS)"
                [ngClass]="
                  sharedData?.headerTab === CONSTANTS.LOCATIONS
                    ? 'dropdown-item pl-5 active'
                    : 'dropdown-item pl-5'
                "
              >
                {{ 'LOCATIONS' | translate }} <span class="sr-only"></span
              ></a>
              <a
                (click)="onSelected(CONSTANTS.USERS)"
                [ngClass]="
                  sharedData?.headerTab === CONSTANTS.USERS
                    ? 'dropdown-item pl-5 active'
                    : 'dropdown-item pl-5'
                "
              >
                {{ 'USERS' | translate }}<span class="sr-only"></span>
              </a>
            </span>

            <a class="dropdown-item pl-5" (click)="viewAccountSetting()"
              >{{ 'ACCOUNT_SETTINGS' | translate }}
            </a>
            <a class="dropdown-item pl-5" (click)="viewUserProfile()"
              >{{ 'USER_PROFILE' | translate }}
            </a>
            <a class="dropdown-item pl-5" (click)="helpFaqs()">
              {{ 'HELP_FAQ' | translate }}
            </a>
            <div class="dropdown-divider"></div>
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 my-4 px-5">
              <button
                class="btn btn-danger lgn-btn"
                type="submit"
                (click)="logout()"
              >
                {{ 'LOGOUT' | translate }}
              </button>
            </div>
            <br />
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
